import { Injectable }               from '@angular/core';
import { Observable }               from 'rxjs/Rx';
import { Globals }                  from './../common/globals';
import { MatSnackBar }               from '@angular/material';

@Injectable()
export class UploadService {

  public progress: any;
  public progressObserver: any;

  constructor (private globals: Globals, public snackbar: MatSnackBar) {
    this.progress = Observable.create(observer => {
      this.progressObserver = observer;
    }).share();
  }

  public makeFileRequest(url: string, params: string[], files: File[]): Observable<any> {
    let observable =
      Observable.fromPromise(new Promise((resolve, reject) => {
        let formData = new FormData();
        let xhr = new XMLHttpRequest();

        for (let i = 0; i < files.length; i++) {
          formData.append('uploads[]', files[i], files[i].name);
        }

        xhr.onreadystatechange = () => {
          if (xhr.readyState === 4) {
            if (xhr.status === 200) {
              resolve(xhr.response);
            } else {
              reject(xhr.response);
            }
          }
        };

        xhr.upload.onprogress = (event) => {
          this.progress = Math.round(event.loaded / event.total * 100);
          if (!!this.progressObserver) {
            this.progressObserver.next(this.progress);
          }
        };

        xhr.open('POST', this.globals.GetUrlPrefix() + url, true);
        let auth = sessionStorage.getItem('id_token');
        xhr.setRequestHeader('Authorization', 'Bearer ' + auth);
        xhr.send(formData);
    }));

    return observable;
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/shared/upload.service.ts